(ns frontend.view.components.timeline.view
  (:require
   [reagent.core :as r]
   [common.localization :as loc]
   [frontend.view.components.timeline.filters.view :as filters]
   [frontend.view.components.timeline.events :as events]
   [frontend.view.components.timeline.db :as db]
   [frontend.view.components.timeline.entry.declaration :as te]
   [frontend.view.components.timeline.entry.default-item :as default-item]
   ;; Add your custom time line entry component here
   [frontend.view.components.timeline.entry.attachment-uploaded]
   [frontend.view.components.timeline.entry.comment-create]
   [frontend.view.components.timeline.entry.phone-call-log]
   [frontend.view.components.timeline.entry.meeting-log]
   [frontend.view.components.timeline.entry.person-create]
   [frontend.view.components.timeline.entry.person-update]
   [frontend.view.components.timeline.entry.oppo-add-to-portfolio]
   [frontend.view.components.timeline.entry.oppo-create]
   [frontend.view.components.timeline.entry.oppo-move]
   [frontend.view.components.timeline.entry.sales-opportunity-move]
   [frontend.view.components.timeline.entry.exit-opportunity-move]
   [frontend.view.components.timeline.entry.fundraising-opportunity-move]
   [frontend.view.components.timeline.entry.oppo-pass]
   [frontend.view.components.timeline.entry.oppo-put-on-hold]
   [frontend.view.components.timeline.entry.oppo-reactivate]
   [frontend.view.components.timeline.entry.oppo-remove-attachment]
   [frontend.view.components.timeline.entry.oppo-resurrect]
   [frontend.view.components.timeline.entry.oppo-update]
   [frontend.view.components.timeline.entry.oppo-disable]
   [frontend.view.components.timeline.entry.company-create]
   [frontend.view.components.timeline.entry.company-update]
   [frontend.view.components.timeline.entry.company-remove-attachment]
   [frontend.view.components.timeline.entry.webentry-resolve]
   [frontend.view.components.timeline.entry.task-create]
   [frontend.view.components.timeline.entry.task-complete]
   [frontend.view.components.timeline.entry.task-reactivate]
   [frontend.view.components.timeline.entry.task-disable]
   [ui.components.card.view :as card]))

(defn component
  []
  (events/init)
  (r/create-class
   {:display-name   "zap-timeline"
    :reagent-render (fn [{:keys [timeline-entries accounts target-id filters tools target-type target-person target-company show-timeline-entries!]}]
                      [card/card
                       [card/header
                        [:h2 (loc/tr :recent-activity)]]

                       [card/body
                        [:div.zap-timeline
                         (when filters
                               [:section.zap-timeline-toolbar.clearfix
                                [filters/component filters]])
                         [:ul {:class-name "timeline"}
                          (doall (for [entry timeline-entries
                                       :when (events/filter-entry db/filters-state entry)]
                                   ^{:key (str "tl-" (:db/id entry))}
                                   [te/timeline-entry-view
                                    {:entry          entry
                                     :accounts       accounts
                                     :target-id      target-id
                                     :target-type    target-type
                                     :target-person  target-person
                                     :target-company target-company}]))
                          (when (and show-timeline-entries! (> (:count @db/state) 0))
                                [default-item/timeline-item-view-template
                                 {:click-handler show-timeline-entries!
                                  :id            "show_all_btn"
                                  :icon-div      (r/as-element
                                                  [:div.timeline-item-badge-container-badge
                                                   {:class (str "timeline-item-badge-container-badge--green")}
                                                   [:i.fal.fa-ellipsis-h]])
                                  :title         (loc/tr :timeline/show-all)
                                  :timestamp     nil
                                  :body          nil}])]]]])}))
